import { createFileRoute } from '@tanstack/react-router'

import { validateProjectPickerSearch } from '@/components/Customer/project-picker-search'
import { CustomerProjects } from '@/components/Customer/ProjectOverview'

export const Route = createFileRoute('/customer/project/$projectId/')({
  validateSearch: validateProjectPickerSearch,
  component: CustomerProjects,
})
